import React from 'react';
import { Target, TrendingUp, Rocket } from 'lucide-react';

const WhoWeWorkWith = () => {
  const clients = [
    {
      icon: Target,
      title: 'Dijitalden gerçek gelir hedefleyen markalar',
      description: 'Sadece görünürlük değil, ölçülebilir büyüme ve gelir artışı arayan işletmeler.'
    },
    {
      icon: TrendingUp,
      title: 'Trafiği var ama dönüşümü düşük işletmeler',
      description: 'Ziyaretçi sayısı yüksek ancak satışa dönüşmeyen web siteleri için optimizasyon.'
    },
    {
      icon: Rocket,
      title: 'Ölçeklenmek isteyen girişimler',
      description: 'Hızlı büyüme için veri odaklı sistemler ve otomasyon altyapısı kurmak isteyenler.'
    }
  ];

  return (
    <section className="py-20 bg-slate-900 relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute w-[500px] h-[500px] bg-emerald-500/10 rounded-full blur-3xl top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 animate-pulse"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Kimler İçin Çalışıyoruz?
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {clients.map((client, index) => (
            <div
              key={index}
              className="bg-slate-800/40 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-8 hover:border-emerald-500/50 transition-all duration-500"
              style={{
                animation: 'fade-in-up 0.8s ease-out both',
                animationDelay: `${index * 0.15}s`
              }}
            >
              {/* Icon */}
              <div className="relative w-14 h-14 mb-6">
                <div className="absolute inset-0 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-xl flex items-center justify-center">
                  <client.icon className="w-7 h-7 text-white" />
                </div>
              </div>

              <h3 className="text-xl font-bold text-white mb-3 leading-tight">
                {client.title}
              </h3>

              <p className="text-gray-400 text-sm leading-relaxed">
                {client.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWeWorkWith;
